import ContainerHomGradientBorder from './ContainerHomGradientBorder'

export { ContainerHomGradientBorder }
